// Maps IQE project status from API response to UI status

import type { IqeProjectStatus, TestRun } from '../../interfaces/ui';
import type { TestRunResponseData } from '../../interfaces/api/responses/saveProject.response';
import type { IqeApiStatus } from '../../interfaces/api/responses/saveProject.response';
import { IQE_PROJECT_STATUS_MAP } from '../../constants';
import { parseDateSafely } from '../../utils';

export function toUiProjectStatus(
  apiStatus: IqeApiStatus | string,
): IqeProjectStatus {
  const normalizedStatus = (apiStatus || '')
    .trim()
    .toUpperCase() as IqeApiStatus;
  return IQE_PROJECT_STATUS_MAP[normalizedStatus];
}

export function toTestRuns(runData: TestRunResponseData): TestRun {
  const passRateStr = runData.passRate || '0';
  const passRate = parseFloat(passRateStr.replace('%', '')) || 0;
  const skipped =
    runData.skipped == null || runData.skipped === ''
      ? undefined
      : parseInt(runData.skipped, 10) || 0;

  return {
    transactionId: runData.transactionId,
    operation: runData.operation,
    status: runData.status,
    testCases: parseInt(runData.testCases, 10) || 0,
    passed: parseInt(runData.passed, 10) || 0,
    failed: parseInt(runData.failed, 10) || 0,
    skipped,
    passRate,
    startedAt: parseDateSafely(runData.startedAt),
    finishedAt: parseDateSafely(runData.finishedAt),
    duration: parseInt(runData.duration || '0', 10) || 0,
    dashboardUrl: runData.dashboardUrl || undefined,
    reportUrl: runData.reportUrl || undefined,
    statusReason: runData.statusReason || undefined,
  };
}
